// extracted by mini-css-extract-plugin
export default {"root":"ProfilePage_root__f2mkP","header":"ProfilePage_header__ArNSr"};